import type { TefComs4csMicroFrontend } from '@mfe-4cs/components/tef-coms4cs';
import { html, TemplateResult } from 'lit';
import { ifDefined } from 'lit/directives/if-defined.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { FeatureValueStore } from '@mfe-4cs/state/FeatureValueStore';
import { comsStore } from '@mfe-4cs/state/ComsStore';

function featureLabel(this: TefComs4csMicroFrontend, feat: FeatureValueStore) {
  return feat.description === feat.title
    ? unsafeHTML(feat.title)
    : this.getTemplateFn('tooltipTemplate')(comsStore.config?.styleContext as string, feat.description, feat.title);
}

export function featureTemplate(
  this: TefComs4csMicroFrontend,
  feature: FeatureValueStore,
  deprecated: boolean,
): TemplateResult {
  return html`
    <tef-coms-multi-checkbox
      value="${ifDefined(feature.granted)}"
      @change=${(event: { detail: boolean; }) => { feature.change(event.detail); }}
      ?disabled="${(comsStore.identity?.readonly || deprecated) ?? false}"
    >
      <p>${featureLabel.bind(this)(feature)}</p>
    </tef-coms-multi-checkbox>
  `;
}
